import HttpService from "../base.service/HttpService";

export default class MonitoringService extends HttpService {
  getPgbUnavailableSpkluDc(param) {
    const api = process.env.VUE_APP_API + "/dashboardSpklu/detail-unavailable";
    return this.get(param, api);
  }

  exportUnavailableSpkluDC(param) {
    const api =
      process.env.VUE_APP_API + "/dashboardSpklu/export-detail-unavailable";
    return this.getFile({}, api, param.name);
  }

  getPgbSpkluNonActive(param) {
    const api = process.env.VUE_APP_API + "/dashboardSpklu/detail-nonactive";
    return this.get(param, api);
  }

  getListAntrian(param) {
    const api = process.env.VUE_APP_API + "/api/monitoring/antrian/list";
    return this.get(param, api);
  }
}
